import ko from 'knockout';
import _ from 'lodash';
import templateMarkup from 'raw-loader!./historicalcapacitydetail-widget.html';
import moment from 'moment-timezone';
import LoginService from "../../../services/login.service";


    function HistoricalCapacityDetailWidget(params) {
        var self = this;
        self.params = params;
        this.observableOptions = params.observableOptions;
        this.observableData = params.observableData;
        self.panelTemplate = params.panelTemplate;
        self.widgetSignals = params.widgetSignals;

        self.capacityDateTime = ko.observable(params.viewLevelOptions().capacityDateTime);
        self.callsCount = ko.observable(0);

        self.subscriptions = [];

        self.getObsParams = function (optschanged) {
            if (_.isEmpty(params.observableParamsList) || _.isEmpty(_.get(params.viewLevelOptions(), 'capacityDateTime'))) {
                return null;
            }
            var obsparams = params.observableParamsList[0]();
            var paramsTemp = params.viewLevelOptions();
            var options = params.observableOptions();
            var queryColumn = _.get(self.panelTemplate, 'panelSettings.queryColumn');

            obsparams.queryId = 'CapacityDetailsParticipantsXml'; // Query for Capacity Details grid
            paramsTemp.dataset = _.get(self.panelTemplate, 'panelSettings.dataset'); // this is needed for export to work correctly

            paramsTemp.pageNum = (optschanged === true) ? options.pageNum : 1;
            paramsTemp.pageSize = options.pageSize;

            paramsTemp.sortColumn = "";

            if (options.displayDetail) {
                paramsTemp.sortIndex = options.sortIndex ? options.sortIndex - 1 : 0;

                if (paramsTemp.sortIndex > (options.displayDetail.length - 1)) {
                    paramsTemp.sortIndex = 0;
                }

                if (_.isString(options.displayDetail[paramsTemp.sortIndex]) && !_.isEmpty(options.displayDetail[paramsTemp.sortIndex])) {
                    paramsTemp.sortColumn = options.displayDetail[paramsTemp.sortIndex];
                    paramsTemp.sortColumn = paramsTemp.sortColumn + ((options.sortAsc === false) ? ' DESC' : ' ASC');
                } else {
                    paramsTemp.sortColumn = '';
                }
            }

            if (!_.isEmpty(paramsTemp.WhereConditionObj) && !_.isEmpty(paramsTemp.WhereConditionObj[0].conditions)) {
                var startTimeMatch = _.find(paramsTemp.WhereConditionObj[0].conditions,
                { "selectedLhs": queryColumn + ".starttime" });
                var endTimeMatch = _.find(paramsTemp.WhereConditionObj[0].conditions,
                { "selectedLhs": queryColumn + ".endtime" });

                if (startTimeMatch) {
                    startTimeMatch.rhsText = paramsTemp.capacityDateTime;
                } else {
                    paramsTemp.WhereConditionObj[0].conditions.push({
                        "selectedLhs": queryColumn + ".starttime",
                        "lhstitle": "Start Time",
                        "selectedOperator": "<=",
                        "optitle": "is prior to",
                        "valueType": "datetime",
                        "selectedConjunction": "AND",
                        "rhsText": paramsTemp.capacityDateTime,
                        "listtype": false
                    });
                }

                if (endTimeMatch) {
                    endTimeMatch.rhsText = paramsTemp.capacityDateTime;
                } else {
                    paramsTemp.WhereConditionObj[0].conditions.push({
                        "selectedLhs": queryColumn + ".endtime",
                        "lhstitle": "End Time",
                        "selectedOperator": ">=",
                        "optitle": "is after",
                        "valueType": "datetime",
                        "selectedConjunction": "AND",
                        "rhsText": paramsTemp.capacityDateTime,
                        "listtype": false
                    });
                }
                paramsTemp.WhereCondition = JSON.stringify(paramsTemp.WhereConditionObj);
            }
            obsparams.paramsJson = ko.toJSON(paramsTemp);
            return obsparams;
        };

        self.setObsParams = function (optschanged) {
            var obsparams = self.getObsParams(optschanged);
            if (!obsparams) {
                return;
            }

            let datetime = moment.utc(params.viewLevelOptions().capacityDateTime);
            var time = datetime.format('hh:mm:ss A');
            if (LoginService.userObject.farmG2) {
                // convert time from UTC to org time and show time zone
                datetime = moment(datetime).tz(LoginService.userObject.timezoneId);
                time =  datetime.format('hh:mm:ss A z');
            }

            self.capacityDateTime(time);

            if (self.widgetSignals) {
                self.widgetSignals.dataRequested.dispatch();
            }
            params.observableParamsList[0](obsparams);
        };

        self.subscriptions.push(params.viewLevelOptions.subscribe(self.setObsParams));
        self.subscriptions.push(self.observableData.subscribe(function () {
            self.DataUpdated();
        }));
        self.subscriptions.push(self.observableOptions.subscribe(function () { self.setObsParams(true); }));
    }

    HistoricalCapacityDetailWidget.prototype.RefreshData = function() {
        var self = this;
        var data = self.observableData();

        if (!_.isEmpty(data)) {
            self.callsCount(data.maxCount);

            if (data.loadFromCacheCallback) {
                var params = self.getObsParams(false);
                if (!params) {
                    return;
                }
                if (!data.loadFromCacheCallback(params, data.context)) {
                    self.setObsParams(false);
                }
            }
        }
    };

    HistoricalCapacityDetailWidget.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    HistoricalCapacityDetailWidget.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });

    };

    export default { viewModel: HistoricalCapacityDetailWidget, template: templateMarkup };
